import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback, useRef } from 'react';
import _ from 'lodash';
import { GRAPH_API_FRAGMENT_DEFINITION, GRAPH_API_FRAGMENT_REFERENCE, } from '../../../utils/symbols';
import { searchListings, ListingSearchFieldFragment } from './searchListings';
import SearchField from '../searchField';
import ListingItem from './listingItem';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const DEBOUNCE_WAIT_FOR_SEARCH_TYPING_MS = 500;
const ListingSearchField = ({ onChange, onBlur, placeholder = 'Search by Listing Id (in quotes) or by address', viewMode, onChangeCurrentListing, currentListing, ...rest }) => {
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const fetchCounter = useRef(0);
    const fetchListings = useCallback(async (searchTerm, currentFetchId) => {
        const results = await searchListings(searchTerm);
        if (currentFetchId === fetchCounter.current) {
            const content = results?.data?.content || [];
            setResults(content);
        }
    }, []);
    const debouncedFetchListings = useRef(_.debounce(async (value) => {
        setLoading(true);
        const currentFetchId = ++fetchCounter.current;
        await fetchListings(value, currentFetchId);
        setLoading(false);
    }, DEBOUNCE_WAIT_FOR_SEARCH_TYPING_MS)).current;
    const onSearchChange = useCallback(async (_e, { value }) => {
        await debouncedFetchListings(value);
    }, [debouncedFetchListings]);
    const resultRenderer = (listing) => {
        return _jsx(ListingItem, { elmId: 'testing', listing: listing });
    };
    const onResultSelect = (_e, data) => {
        onChangeCurrentListing(data.result.listing);
        onChange(data.result.key || '');
    };
    const resultsMapped = results.map(result => ({
        key: result?.listing_id,
        title: result?.listing_id,
        description: result?.listing_id,
        renderer: () => resultRenderer(result),
        listing: result,
    }));
    return (_jsxs("div", { className: cx('container', { expanded: currentListing }), children: [_jsx(SearchField, { results: resultsMapped, onSearchChange: onSearchChange, onResultSelect: onResultSelect, noResultsMessage: 'No results found', selectFirstResult: true, showNoResults: true, className: cx('listing-search-field'), loading: loading, placeholder: placeholder, viewMode: viewMode, borderBottom: 'none', onChange: onChange, ...rest }), _jsx("div", { className: cx({ 'listing-item-cover-mode': currentListing }), children: _jsx(ListingItem, { elmId: 'listing_item', listing: currentListing || null, onClose: () => {
                        onChangeCurrentListing(null);
                        onChange('');
                    }, viewMode: viewMode }) })] }));
};
ListingSearchField[GRAPH_API_FRAGMENT_DEFINITION] = ListingSearchFieldFragment;
ListingSearchField[GRAPH_API_FRAGMENT_REFERENCE] = `...ListingSearchFields`;
export default ListingSearchField;
//# sourceMappingURL=index.js.map